import { useContext } from "react";
import { ValidationControlContext } from "@/contexts/ValidationControlProvider";

export function useValidationControl() {
  const context = useContext(ValidationControlContext);

  if (!context) {
    throw new Error(
      "useValidationControl must be used within a ValidationControlProvider",
    );
  }

  return context;
}
